import { FC } from 'react';
import { Link } from 'react-router-dom';

import { ButtonStyled, HeaderStyled, LinkStyled } from './Header.styled';
import FlexContainer from 'components/FlexContainer/FlexContainer';
import ArrowLeftIcon from 'icons/ArrowLeftIcon';
import HomeIcon from 'icons/HomeIcon';

const Header: FC = () => {
  return (
    <HeaderStyled>
      <FlexContainer justify="center">
        <LinkStyled to="/">
          <img src="/images/logo.png" alt="WarCloud logo" />
        </LinkStyled>
      </FlexContainer>
      <Link to="/" title="Back to Homepage">
        <ButtonStyled type="button" variant="outline" size="xl" icon={<HomeIcon />}>
          <ArrowLeftIcon />
        </ButtonStyled>
      </Link>
    </HeaderStyled>
  );
};

export default Header;
